/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createTxtTemplate } from '../fn/text-template/create-txt-template';
import { CreateTxtTemplate$Params } from '../fn/text-template/create-txt-template';
import { deleteTemplate } from '../fn/text-template/delete-template';
import { DeleteTemplate$Params } from '../fn/text-template/delete-template';
import { getTxtTemplates } from '../fn/text-template/get-txt-templates';
import { GetTxtTemplates$Params } from '../fn/text-template/get-txt-templates';
import { modifyTemplate } from '../fn/text-template/modify-template';
import { ModifyTemplate$Params } from '../fn/text-template/modify-template';
import { TxtTemplate } from '../models/txt-template';

@Injectable({ providedIn: 'root' })
export class TextTemplateService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `modifyTemplate()` */
  static readonly ModifyTemplatePath = '/api/template/{id}';

  /**
   * Edits a medical history text template with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `modifyTemplate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  modifyTemplate$Response(params: ModifyTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return modifyTemplate(this.http, this.rootUrl, params, context);
  }

  /**
   * Edits a medical history text template with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `modifyTemplate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  modifyTemplate(params: ModifyTemplate$Params, context?: HttpContext): Observable<void> {
    return this.modifyTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createTxtTemplate()` */
  static readonly CreateTxtTemplatePath = '/api/template/{id}';

  /**
   * Creates a medical history text template with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTxtTemplate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTxtTemplate$Response(params: CreateTxtTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createTxtTemplate(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a medical history text template with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createTxtTemplate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTxtTemplate(params: CreateTxtTemplate$Params, context?: HttpContext): Observable<void> {
    return this.createTxtTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteTemplate()` */
  static readonly DeleteTemplatePath = '/api/template/{id}';

  /**
   * Deletes a medical history text template with the given id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTemplate()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTemplate$Response(params: DeleteTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteTemplate(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a medical history text template with the given id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTemplate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTemplate(params: DeleteTemplate$Params, context?: HttpContext): Observable<void> {
    return this.deleteTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getTxtTemplates()` */
  static readonly GetTxtTemplatesPath = '/api/template/abreviations';

  /**
   * Returns medical history text template abreviations for the logged tenant
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTxtTemplates()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTxtTemplates$Response(params?: GetTxtTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TxtTemplate>>> {
    return getTxtTemplates(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns medical history text template abreviations for the logged tenant
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTxtTemplates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTxtTemplates(params?: GetTxtTemplates$Params, context?: HttpContext): Observable<Array<TxtTemplate>> {
    return this.getTxtTemplates$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TxtTemplate>>): Array<TxtTemplate> => r.body)
    );
  }

}
